import React, { createContext, useReducer } from "react";
import { OutboundOverviewAMZLReducer } from "../reducers/OutboundOverviewAMZLReducer";

export const RouteContext = createContext();

const RouteContextProvider = (props) => {
  const data = {
    routeList: [],
    routesNotAssignedCount: 0,
    lastUpdated: null,
  };
  const [viewModel, dispatch] = useReducer(OutboundOverviewAMZLReducer, data);
  return (
    <RouteContext.Provider value={{ viewModel, dispatch }}>
      {props.children}
    </RouteContext.Provider>
  );
};

export default RouteContextProvider;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/context/RouteContextProvider.js